import Box from '@mui/material/Box'
import CheckIcon from '@mui/icons-material/Check'
import Markdown from '../Markdown'
import { bodyText, colours } from '../player/playerStyles'

const SummaryBlock = ({ block }) => (
  <Box component="ul" sx={{ listStyle: 'none', m: 0, p: 0, maxWidth: '74ch' }}>
    {block.points.map((point, index) => (
      <Box component="li" key={index} sx={{ display: 'flex', gap: 1.25, mb: 1.5 }}>
        <CheckIcon sx={{ color: colours.good, mt: '3px', flexShrink: 0 }} aria-hidden="true" />
        <Markdown sx={bodyText}>{point}</Markdown>
      </Box>
    ))}
  </Box>
)

export default SummaryBlock
